import { differenceWith, isEqual } from 'lodash';
import { DatasetManager, DatasetManagerNotifySubject } from '@goodt-wcore/managers';

/**
 * @typedef {import('@goodt-common/data').IDatasetRequestProps} IDatasetRequestProps
 */

/**
 *
 * @param dataProviderId
 * @param $from
 * @return {{dataProviderId: *, datasetCode: *}}
 * @constructor
 */
const DatasourceMetaMapper = ({ dataProviderId, query: { $from } }) => ({
    dataProviderId,
    datasetCode: $from
});

export const ElemDatasetPropChangeMixin ={
    watchEditor: {
        datasetRequests: {
            /**
             * @param {(DatasetRequest|null)[]} newDatasetRequests
             * @param {(DatasetRequest|null)[]} [oldDatasetRequests=[]]
             */
            handler(newDatasetRequests, oldDatasetRequests = []) {
                this.resolveDatasetsChanged(newDatasetRequests, oldDatasetRequests);
            }
        }
    },
    methods: {
        /**
         * @param {IDatasetRequestProps[]} newDatasetRequests
         * @param {IDatasetRequestProps[]} oldDatasetRequests
         * @return {PropChangeContext|null} context
         */
        resolveDatasetsChanged(newDatasetRequests, oldDatasetRequests) {
            const newDatasetsMeta = newDatasetRequests.map(DatasourceMetaMapper);
            const oldDatasetsMeta = oldDatasetRequests.map(DatasourceMetaMapper);

            const added = differenceWith(newDatasetsMeta, oldDatasetsMeta, isEqual);
            const deleted = differenceWith(oldDatasetsMeta, newDatasetsMeta, isEqual);

            if (added.length + deleted.length > 0) {
                const { id: elemId } = this;
                DatasetManager.instance.notify(DatasetManagerNotifySubject.DATASET_USAGE, {
                    added: added.map((meta) => ({
                        ...meta,
                        elemId
                    })),
                    deleted: deleted.map((meta) => ({
                        ...meta,
                        elemId
                    }))
                });
            }
        }
    }
};
